var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "external-profile-links skew-11-neg"
  }, [_c('div', {
    staticClass: "external-profile-links__content"
  }, [_c('a', {
    attrs: {
      "title": "LinkedIn",
      "href": "https://ie.linkedin.com/pub/graham-bartley/ba/590/511",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_c('img', {
    staticClass: "link-bubble",
    attrs: {
      "src": require("../assets/linkedin-logo.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "title": "GitHub",
      "href": "https://github.com/grabartley",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_c('img', {
    staticClass: "link-bubble",
    attrs: {
      "src": require("../assets/github-logo.png")
    }
  })])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6e17d54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalProfileLinks.vue
// module id = KXfa
// module chunks = 0